<div class="proposal-dialog">
  <!-- Dialog Header -->
  <div class="dialog-header">
    <div class="header-icon">
      <mat-icon>{{copyScope ? 'content_copy' : 'description'}}</mat-icon>
    </div>
    <h2>{{copyScope ? 'Copy' :'Create'}} Proposal</h2>
    <button class="close-btn" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Dialog Content -->
  <div class="dialog-content">
    @if (!copyScope) {
      <div [formGroup]="proposalForm">
        <div class="form-row">
          <div class="form-group col-12 add_bider_draw">
            <label  class="custom_label">Bid *</label>
            <div class="input_with_external_btn">
              <!-- <ng-select
              id="customer_id"
              [items]="bids"
              placeholder="Select bid"
              [closeOnSelect]="true"
              formControlName="bid_id"
              bindValue="id"
              bindLabel="name"
              >
            </ng-select> -->
            <app-scrollable-search-field
              id="customer_id"
              [dataService]="bidDataService"
              [dataServiceFunctionName]="'search'"
              [sortBy]="'bid_number'"
              [sortOrder]="'desc'"
              [searchPlaceHolder]="'Select bid'"
              [labelKey]="'name'"
              [formDataMapper]="{'id': 'id', 'name' : 'name' , 'tenants': 'tenants'}"
              [keyNameToShowWhenSelected]="'name'"
              [inputVal]="bidDetail ? bidDetail.name : ''"
              [addButtonLabel]="'Add bid'"
              [additionalParams]="tenantProps"
              (selectedValueChange)="selectedValueChange($event)"
              (addButtonCallback)="createBid()"
              [markCtrlTouched]="proposalForm.get('bid_id')?.touched"
              >
            </app-scrollable-search-field>
            <button appPermission="BIDS-PROPOSAL-RELATED-CREATE" type="button" (click)="createBid()"  class="btn_add_more_sm">+</button>
          </div>
          <!-- <app-validation-error  [formGroup]="proposalForm" [controlName]="'bid_id'"></app-validation-error> -->
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-12 add_bider_draw">
          <label  class="custom_label">Office *</label>
          <div class="input_with_external_btn">
            <ng-select
              id="tenant_id"
              [items]="offices"
              placeholder="Select Office"
              [closeOnSelect]="true"
              formControlName="tenant_id"
              bindValue="id"
              bindLabel="name"
              (change)="onCompanyChangeProposalCreate($event)"
              >
            </ng-select>
          </div>
          <app-validation-error  [formGroup]="proposalForm" [controlName]="'tenant_id'"></app-validation-error>
        </div>
      </div>
      @if (!customer_id) {
        <div class="form-row">
          <div class="form-group col-12 add_bider_draw">
            <label  class="custom_label">Bidder *</label>
            <div class="input_with_external_btn">
              <ng-select
                id="customer_id"
                [items]="customers"
                placeholder="Select Bidder"
                [closeOnSelect]="true"
                formControlName="customer_id"
                bindValue="id"
                bindLabel="company_name"
                >
              </ng-select>
            </div>
            <app-validation-error  [formGroup]="proposalForm" [controlName]="'customer_id'"></app-validation-error>
          </div>
        </div>
      }
      @if (!customer_id && offices.length > 0 && customers.length == 0) {
        <div class="cards">
          <article class="information [ card-info ]">
            <span class="tag"></span>
            <h2 class="title">No bidders found! </h2>
            <p class="info">Please add bidders in bid</p>
          </article>
        </div>
      }
    </div>
  }
  @if (copyScope) {
    <ng-container [formGroup]="copyProposalForm">
      <div class="user-search-wrapper">
        <div class="scopes-title-wrapper ">
          <span class="scopes-title ">From Proposal</span>
        </div>
        <div class="search-ui" style="padding-bottom: 0px;border-bottom: none">
          <ng-container >
            <app-search-field [searchAbleDataService]="proposalDataService"
              searchAbleFunctionName="search"
              [searchAbleParams]="proposalSearchAbleParams"
              (onRemoveSelection)="onRemoveItemSelect($event)"
              [labelKey]="'detail_title'"
              [selectedItem]="defaultCopyProposalData"
              [labelKey]="'detail_title'"
              [showSelectionDiv]="true"
              [rightLabelKey]="'proposal_total'"
              [rightLabelType]="'currency'"
              [searchPlaceHolder]="'Search proposal'" (onSelectValue)="onItemSelect($event)">
            </app-search-field>
          </ng-container>
        </div>
      </div>
      <div class="tabs-ui">
        <div class="tabs-ui-contents">
          <div class="tabs-ui-content tabs-ui-content-active">
            @if (selectedProposal) {
              <div class="scopes-title-wrapper mt-1">
                <span class="scopes-title ">Scopes</span>
              </div>
            }
            @if (selectedProposal) {
              <div class="scopes-wrapper scrollable-container" formArrayName="scopes">
                @if (selectedProposal) {
                  <div class="row">
                    @for (scope of cloneScopes; track scope; let scopeIndex = $index) {
                      <div class="col-md-12 mt-1" [formGroupName]="scopeIndex">
                        <div class="scope-checkbox-wrapper proposal-scope-checkbox-wrapper">
                          <mat-checkbox class="bidone-checkbox" formControlName="is_checked"  (change)="onChangeScopes($event, scope)">
                            <div class="row">
                              <div class="col-md-8">
                                {{scope?.scope_name}}
                                <br>
                                  <span style="color: #FF6600;">{{scope?.service_name}}</span>
                                </div>
                                <div class="col-md-4" style="text-align: end; align-content: center;">
                                  <span style="color: #FF6600;font-weight: 600;">
                                    {{scope?.final_sale_quote  | currency}}
                                  </span>
                                </div>
                              </div>
                            </mat-checkbox>
                          </div>
                        </div>
                      }
                    </div>
                  }
                  @if (!selectedProposal) {
                    <div class="cards">
                      <article class="information [ card-info ]">
                        <span class="tag"></span>
                        <h2 class="title">No scopes found! </h2>
                        <p class="info">Please select a proposal to view associated scopes</p>
                      </article>
                    </div>
                  }
                  @if (selectedProposal && !cloneScopes.length) {
                    <div class="cards">
                      <article class="information [ card-info ]">
                        <h2 class="title">No scopes found! </h2>
                        <p class="info">No scopes associated with selected proposal</p>
                      </article>
                    </div>
                  }
                </div>
              }
              <div class="scopes-title-wrapper mt-2">
                <span class="scopes-title ">To Bid</span>
              </div>
              <div class="scopes-wrapper ">
                <div class="input_with_external_btn">
                  <div class=" add_bider_draw">
                    <app-scrollable-search-field
                      style="width: 100%;"
                      id="customer_id"
                      [dataService]="bidDataService"
                      [dataServiceFunctionName]="'search'"
                      [sortBy]="'bid_number'"
                      [sortOrder]="'desc'"
                      [searchPlaceHolder]="'Select bid'"
                      [labelKey]="'name'"
                      [formDataMapper]="{'id': 'id', 'name' : 'name','customers':'customers','contacts':'contacts', 'tenants':'tenants'}"
                      [keyNameToShowWhenSelected]="'name'"
                      [inputVal]="bidDetail ? bidDetail.name : ''"
                      [addButtonLabel]="'Add bid'"
                      (selectedValueChange)="onCopyBidValueChange($event)"
                      (addButtonCallback)="createBid()"
                      [markCtrlTouched]="proposalForm.get('bid_id')?.touched"
                      >
                    </app-scrollable-search-field>
                    <!-- <button style="margin-top: -20px;"  appPermission="BIDS-PROPOSAL-RELATED-CREATE" type="button" (click)="createBid()"  class="btn_add_more_sm">+</button> -->
                  </div>
                  <!-- <app-validation-error  [formGroup]="proposalForm" [controlName]="'bid_id'"></app-validation-error> -->
                </div>
                <div>
                  <span class="scopes-title ">Office *</span>
                </div>
                <div>
                  <div>
                    <div>
                      <ng-select
                        id="tenant_id"
                        [items]="offices"
                        placeholder="Select Office"
                        [closeOnSelect]="true"
                        formControlName="tenant_id"
                        bindValue="id"
                        bindLabel="name"
                        (change)="onCompanyChange($event)"
                        >
                      </ng-select>
                    </div>
                    <app-validation-error  [formGroup]="copyProposalForm" [controlName]="'tenant_id'"></app-validation-error>
                  </div>
                </div>
                <div class="scopes-title-wrapper mt-1" >
                  <span class="scopes-title ">Bidders</span>
                </div>
                @if (customers && customers.length;) {
                  <div class="bidders-wrapper scrollable-container" formArrayName="customers">
                    <div class="row">
                      @for (customer of customers; track customer; let i = $index) {
                        <div class="col-md-12 mt-1" [formGroupName]="i">
                          <div class="scope-checkbox-wrapper proposal-scope-checkbox-wrapper">
                            <mat-checkbox class="bidone-checkbox" formControlName="is_checked" > {{customer.contact?.full_name}}
                              <!-- <span *ngIf="customer?.tenant?.name">[{{customer?.tenant?.name}}]</span> -->
                              <br>
                                <span style="color: #FF6600;">{{customer?.company_name}}</span>
                              </mat-checkbox>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  }
                  @if (!copyProposalForm.get('bid_id')?.value) {
                    <div class="cards">
                      <article class="information [ card-info ]">
                        <span class="tag"></span>
                        <h2 class="title">No bidders found! </h2>
                        <p class="info">Please select a bid to view associated bidders</p>
                      </article>
                    </div>
                  }
                  @if (copyProposalForm.get('bid_id')?.value && !customers.length) {
                    <div class="cards">
                      <article class="information [ card-info ]">
                        <h2 class="title">No bidders found! </h2>
                        <p class="info">No bidders associated with selected bid</p>
                      </article>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      }
    </div>

    <!-- Dialog Footer -->
    <div class="dialog-footer">
      <button class="btn-cancel" (click)="close()">
        <mat-icon>close</mat-icon>
        Cancel
      </button>
      @if (!copyScope) {
        <button class="btn-submit" (click)="onSubmit()">
          <mat-icon>add</mat-icon>
          <span>Create</span>
        </button>
      }
      @if (copyScope) {
        <button class="btn-submit" [disabled]="processCopyRequestInProgress" (click)="processCopyProposal()">
          <mat-icon>content_copy</mat-icon>
          <span>Copy Proposal</span>
        </button>
      }
    </div>
  </div>
